// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vis-cf-colorByFlexWrapper{align-items:center}.vis-cf-item-wrapper{margin-left:auto;border:1px solid;border-color:#e0e0e0;border-color:hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1)}\n", ""]);
// Exports
module.exports = exports;
